import React from 'react';
import { Upload, Icon } from 'antd';
import Fetch from '../Fetch';

const SingleImageUpload = props => {
    const [state, setState] = React.useState({ loading: false, image: '' });

    const handleChange = (info) => {
        if (info.file.status === 'uploading') {
            setState({ ...state, loading: true });
            return;
        }
        if (info.file.status === 'done') {
            setState({ loading: false, image: Fetch.getUrl(`/public/uploads/studentphotos/${info.file.response.filename}`) })
            props.onDone(info.file.response.filename);
        }
    }

    const uploadButton = (
        <div>
            <Icon type={state.loading ? 'loading' : 'plus'} />
            <div className="ant-upload-text">Upload</div>
        </div>
    );

    return (
        <Upload
            name="avatar"
            listType="picture-card"
            className="avatar-uploader"
            showUploadList={false}
            onChange={handleChange}
            headers={{ Authorization: `Bearer ${Fetch.token}` }}
            {...props}
        >
            {state.image !== '' || props.path !== '' ?
                <img src={state.image === '' ? Fetch.getUrl(`/public/uploads/studentphotos/${props.path}`) : state.image}
                    alt="avatar" width={185} height={170} /> : uploadButton}
        </Upload>
    )
}

export default SingleImageUpload;